// extracted by mini-css-extract-plugin
module.exports = {"root":"IicYF","content":"JcCFR"};